import ProductFilterSidebar from "./Sidebarcardcomponent";
import Productcardimages from "./Productcardimages";
import SectionHeader from "../SectionHeader";
import { useEffect, useState } from "react";
import { http } from "../../axios/axios";
import { getSubCategoryParentId } from "../../helpers/getSubCategoryParentId";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Sidebarcard() {
  const [filters, setFilters] = useState({
    categories: [],
    subCategories: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
    productType: "security",
    category: "",
    subCategory: "",
  });

  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadFilters() {
      try {
        // SECURITY PRODUCTS
        if (selectedFilters.productType === "security") {
          const res = await http.get("/products/filter-options");

          // console.log("Security filter response:", res.data);

          setFilters({
            categories: res.data?.categories || [],
            subCategories: res.data?.subCategories || [],
          });

          return;
        }

        // IT PRODUCTS use the dedicated catalog APIs, not the Security navbar data.
        if (selectedFilters.productType === "it") {
          const [categoryResponse, subCategoryResponse] = await Promise.all([
            http.get("/ip-network/categories", { params: { limit: 1000 } }),
            http.get("/ip-network/subcategories", { params: { limit: 1000 } }),
          ]);

          setFilters({
            categories:
              categoryResponse.data?.categories ||
              categoryResponse.data?.data ||
              [],
            subCategories:
              subCategoryResponse.data?.subCategories ||
              subCategoryResponse.data?.data ||
              [],
          });
        }
      } catch (error) {
        console.error(
          "Error loading product filters:",
          error.response?.data || error,
        );

        setFilters({
          categories: [],
          subCategories: [],
        });
      }
    }

    loadFilters();
  }, [selectedFilters.productType]);

  const filteredSubCategories = selectedFilters.category
    ? filters.subCategories.filter(
        (subCat) =>
          String(getSubCategoryParentId(subCat)) ===
          String(selectedFilters.category),
      )
    : filters.subCategories;

  /*
  |--------------------------------------------------------------------------
  | Load Products According To Product Type + Category + SubCategory
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    async function getProducts() {
      try {
        setLoading(true);

        const params = {
          limit: 8,
        };

        if (selectedFilters.productType === "it") {
          params.catalogType = "ip-network";
          if (selectedFilters.category)
            params.ipNetworkCategory = selectedFilters.category;
          if (selectedFilters.subCategory)
            params.ipNetworkSubCategory = selectedFilters.subCategory;
        } else {
          params.catalogType = "catalog";
          if (selectedFilters.category)
            params.category = selectedFilters.category;
          if (selectedFilters.subCategory)
            params.subCategory = selectedFilters.subCategory;
        }

        let res;

        res = await http.get("/products/filter", { params });

        setProduct(res.data.products || res.data.data || []);
      } catch (error) {
        console.error("Product filter error:", error);
        setProduct([]);
      } finally {
        setLoading(false);
      }
    }

    getProducts();
  }, [
    selectedFilters.productType,
    selectedFilters.category,
    selectedFilters.subCategory,
  ]);

  return (
    <section className="py-12 md:py-16">
      <div className="px-4 sm:px-6 lg:px-8">
        <SectionHeader
          badge="Featured Products"
          title="Explore Security & IT Products"
          description="Top products from our range."
          action={
            <Link
              to="/security-product"
              className="
                group
                inline-flex
                items-center
                gap-2
                text-sm
                font-semibold
                text-slate-700
                hover:text-blue-600
                transition-colors
              "
            >
              View All Products
              <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform"
              />
            </Link>
          }
        />

        <div className="bg-white border border-slate-200 rounded-2xl px-4 py-4 mb-6">
        <div className="relative flex flex-wrap gap-2 md:gap-3 py-3">
  <div
    className="
      flex
      flex-col
      items-center
      text-blue-600
      font-semibold
      text-xs
      sm:text-sm
      pointer-events-none
    "
  >
    <span className="animate-pulse mb-1">
      Click here to choose  
    </span>
          <span className="text-xl animate-bounce leading-none">
      ↓
    </span>
 
  </div>
</div>
          <ProductFilterSidebar
            categories={filters.categories}
            subCategories={filteredSubCategories}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </div>

        {loading ? (
          <div className="py-10 text-center text-slate-500">
            Loading products...
          </div>
        ) : (
          <Productcardimages product={product} />
        )}
      </div>
    </section>
  );
}
